import { trackingId } from "../constants";
import ReactGA from "react-ga";

export const initGA = () => {
  ReactGA.initialize(trackingId);
};
